// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input-module__input--abYkh{box-sizing:border-box;color:#444;background:#fff;border:1px solid #ccc;border-radius:5px;width:100%;padding:.5em;font-size:1rem;font-weight:400;box-shadow:inset 0 1px 1px #0000001a}.Input-module__input--abYkh:focus{border-color:#09c;outline:none;box-shadow:0 0 5px #0099cc1a,inset 0 1px 1px #eee}.Input-module__input--abYkh:focus::placeholder{color:#0000}.Input-module__input--abYkh::placeholder{color:#999}.Input-module__input--abYkh:disabled{color:#999;background:#f6f6f6}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `Input-module__input--abYkh`
};
export default ___CSS_LOADER_EXPORT___;
